import React from 'react';
import './AmenidadesCopal.scss';
import Slider from '../Slider/Slider';
import { SwiperSlide } from "swiper/react";
import { AnimationOnScroll } from 'react-animation-on-scroll';
import "animate.css/animate.min.css";
import { useTranslation } from 'react-i18next';

const AmenidadesCopal = () => {
  const { t } = useTranslation();

  return (
    <div id="amenidades" className='contenedor_amenidades_copal'>
      <div className='amenidades_top_copal'>
        <AnimationOnScroll
          duration={2}
          animateOnce={true}
          animateIn='animate__fadeIn'>
          <div className='subtitulo_ame_copal'>
            <h2 dangerouslySetInnerHTML={{ __html: t('amenitiesCopal.title') }} />
          </div>
        </AnimationOnScroll>
        <div className='list_ame_copal'>
          <div className='colum_list_copal'>
            <img src="/assets/Artemisa/svg-icon-alberca.svg" alt={t('amenitiesCopal.clubhousePool')} />
            <p>{t('amenitiesCopal.clubhousePool')}</p>
          </div>
          <div className='colum_list_copal'>
            <img src="/assets/Iconos/Amenidades/svg-icon-juegos-infantiles.svg" alt={t('amenitiesCopal.playground')} />
            <p>{t('amenitiesCopal.playground')}</p>
          </div>
          <div className='colum_list_copal'>
            <img src="/assets/Iconos/Amenidades/svg-icon-lineal.svg" alt={t('amenitiesCopal.linearPark')} />
            <p>{t('amenitiesCopal.linearPark')}</p>
          </div>
          <div className='colum_list_copal'>
            <img src="/assets/Iconos/Amenidades/svg-icon-dogpark.svg" alt={t('amenitiesCopal.dogPark')} />
            <p>{t('amenitiesCopal.dogPark')}</p>
          </div>
          <div className='colum_list_copal'>
            <img src="/assets/Iconos/Amenidades/svg-icon-ciclovia.svg" alt={t('amenitiesCopal.cyclingTrack')} />
            <p>{t('amenitiesCopal.cyclingTrack')}</p>
          </div>
          <div className='colum_list_copal'>
            <img src="/assets/Iconos/Amenidades/svg-icon-coworking.svg" alt={t('amenitiesCopal.coworking')} />
            <p>{t('amenitiesCopal.coworking')}</p>
          </div>
          <div className='colum_list_copal'>
            <img src="/assets/Iconos/Amenidades/svg-icon-area-verde.svg" alt={t('amenitiesCopal.greenArea')} />
            <p>{t('amenitiesCopal.greenArea')}</p>
          </div>
          <div className='colum_list_copal'>
            <img src="/assets/Iconos/Amenidades/svg-icon-padel.svg" alt={t('amenitiesCopal.padelCourt')} />
            <p>{t('amenitiesCopal.padelCourt')}</p>
          </div>
          <div className='colum_list_copal'>
            <img src="/assets/Iconos/Amenidades/svg-icon-picnics.svg" alt={t('amenitiesCopal.picnicArea')} />
            <p>{t('amenitiesCopal.picnicArea')}</p>
          </div>
          <div className='colum_list_copal'>
            <img src="/assets/Iconos/Amenidades/svg-icon-acceso.svg" alt={t('amenitiesCopal.dualAccess')} />
            <p>{t('amenitiesCopal.dualAccess')}</p>
          </div>
          <div className='colum_list_copal'>
            <img src="/assets/Iconos/Amenidades/svg-icon-caseta.svg" alt={t('amenitiesCopal.gatehouse')} />
            <p>{t('amenitiesCopal.gatehouse')}</p>
          </div>
        </div>
      </div>
      <div id="galeria" className='amenidades_bottom_copal'>
        <Slider nav={false} pag={true}>
          <SwiperSlide>
            <div className="contenedor__amenidades_carousel__slider_copal">
              <img src="./assets/Artemisa/img-parques-artemisa-velasur.jpg" alt="Velasur" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="contenedor__amenidades_carousel__slider_copal">
              <img src="./assets/Artemisa/img-casa-club-artemisa-velasur.jpg" alt="Velasur" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="contenedor__amenidades_carousel__slider_copal">
              <img src="./assets/Artemisa/img-aereo-artemida-velasur.jpg" alt="Velasur" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="contenedor__amenidades_carousel__slider_copal">
              <img src="./assets/Artemisa/img-andadores-artemisa-velasur.jpg" alt="Velasur" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="contenedor__amenidades_carousel__slider_copal">
              <img src="./assets/Artemisa/img-coworking-artemisa-velasur.jpg" alt="Velasur1" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="contenedor__amenidades_carousel__slider_copal">
              <img src="./assets/Artemisa/img-trotapista-artemisa-velasur.jpg" alt="Velasur" />
            </div>
          </SwiperSlide>
        </Slider>
      </div>
    </div>
  );
}

export default AmenidadesCopal;
